import React from 'react';
import {FormattedMessage} from 'react-intl';

export default [
  {
    testimonial: (
      <FormattedMessage
        id="SocialProof.SellerTestimonial.Ben.LA"
        defaultMessage=
          "The StubHub platform simplifies the selling process from beginning to end. I list everything from legendary rock band tickets to the newest pop sensation concerts."
      />),
    name: <FormattedMessage id="SocialProof.SellerName.Ben.LA" defaultMessage="Ben" />,
    location: <FormattedMessage id="SocialProof.Location.Ben.LA" defaultMessage="Los Angeles, California" />,
    category: <FormattedMessage id="SocialProof.SellerCategory.Ben.LA" defaultMessage="Sells Music & Sports Tickets" />
  },
  {
    testimonial: (
      <FormattedMessage
        id="SocialProof.SellerTestimonial.Julia.SF"
        defaultMessage=
          "StubHub made selling my Billie Eilish tickets last minute really fast and easy! They sold in just a day and for more than what I had listed them on other places."
      />),
    name: <FormattedMessage id="SocialProof.SellerName.Julia.SF" defaultMessage="Julia" />,
    location: <FormattedMessage id="SocialProof.Location.Julia.SF" defaultMessage="San Francisco, California" />,
    category: <FormattedMessage id="SocialProof.SellerCategory.Julia.SF" defaultMessage="Sells Music Tickets" />
  },
  {
    testimonial: (
      <FormattedMessage
        id="SocialProof.SellerTestimonial.John.PA"
        defaultMessage=
          "Extra tickets before an event? It has never been easier to sell tickets using StubHub. I would recommend it to anyone who is looking to sell tickets."
      />),
    name: <FormattedMessage id="SocialProof.SellerName.John.PA" defaultMessage="John" />,
    location: <FormattedMessage id="SocialProof.Location.John.PA" defaultMessage="Swarthmore, Pennsylvania" />,
    category: <FormattedMessage id="SocialProof.SellerCategory.John.PA" defaultMessage="Sells Music Tickets" />
  },
  {
    testimonial: (
      <FormattedMessage
        id="SocialProof.SellerTestimonial.John.TX"
        defaultMessage=
          "I've had great success with selling tickets on StubHub, even for those last-minute tickets. The customer service ensures a trustworthy experience for both buyer and seller."
      />),
    name: <FormattedMessage id="SocialProof.SellerName.John.TX" defaultMessage="John" />,
    location: <FormattedMessage id="SocialProof.Location.John.TX" defaultMessage="Austin, Texas" />,
    category: <FormattedMessage id="SocialProof.SellerCategory.John.TX" defaultMessage="Sells Music & Theater Tickets" />
  }
];
